import { render, staticRenderFns } from "./ev6-imgs-swiper.vue?vue&type=template&id=2f1c5631&scoped=true"
import script from "./ev6-imgs-swiper.vue?vue&type=script&lang=js"
export * from "./ev6-imgs-swiper.vue?vue&type=script&lang=js"
import style0 from "./ev6-imgs-swiper.vue?vue&type=style&index=0&id=2f1c5631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c5631",
  null
  
)

export default component.exports